import React, { useState } from "react";
import DigitalIndustrytabsimages from './DigitalIndustrytabsimages';
import Digitalimagestabssingledata from './Digitalimagestabssingledata';
import Digitalthirdtablogs from './Digitalthirdtablogs';
// Card component
const Card = ({ title, description }) => {
    const cardStyles = {
        border: "1px solid #ddd",
        borderRadius: "8px",
        padding: "20px",
        margin: "10px",
        boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
        textAlign: "left",
        width: "280px",
        backgroundColor: "#fff",
    };

    return (
        <div style={cardStyles}>
            <h3 style={{ marginBottom: "10px", fontSize: "18px" }}>{title}</h3>
            <p style={{ fontSize: "14px", color: "#000", }}>{description}</p>
        </div>
    );
};

const DigitalmobilityTabscards = () => {
    const [activeTab, setActiveTab] = useState("tab1");

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    const styles = {
        container: {
            fontFamily: "Arial, sans-serif",
            width: "80%", // You can adjust the width of the container
            margin: "20px auto",

        },
        tabNav: {
            display: "flex",
            justifyContent: "center", // Horizontally center the tabs. Reaming data formating skills also Customersuccesstorycards.js, DigitalBanner.js, CompanyHiringSectionPage.js, ContactForms
            borderBottom: "2px solid #ddd", 
            paddingBottom: "10px",
        },
        tabButton: {
            padding: "10px 20px",
            cursor: "pointer",
            border: "none",
            background: "none",
            fontSize: "16px",
            fontWeight: "bold",
            color: "#555",
            outline: "none",
            transition: "color 0.3s, background-color 0.3s",
            borderRadius: "50px", // Pill shape
            margin: "0 10px", // Spacing between buttons
            backgroundColor: "#f0f0f0", // Default background color
        },
        activeTabButton: {
            borderBottom: "none", // Remove the border from active tab
            backgroundColor: "#009ca5", // Active tab background color
            color: "#fff", // Active tab text color
        },
        tabContent: {
            padding: "20px",
            fontSize: "16px",
            color: "#333",
            lineHeight: "1.5",
            textAlign: "center", // Center the text content
            display: "flex", // Use flexbox to display the cards in a row
            flexWrap: "nowrap", // Prevent cards from wrapping to the next line
            justifyContent: "space-between", // Distribute cards evenly in the row
            gap: "10px", // Add some space between the cards
            width: "100%", // Make the tabContent span the full width of the container
        },
    };



    return (
        <div><h1 style={{ textAlign: 'center',marginBottom:"50px" }}> <span style={{ color: "rgb(0 156 165)" }}> Our </span> Partners</h1>
            <div style={styles.container}>
                <div style={styles.tabNav}>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(activeTab === "tab1" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab1")}
                     >
                        All Partners
                    </button>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(activeTab === "tab2" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab2")}
                    >
                        Product Life Management
                    </button>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(activeTab === "tab3" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab3")}
                    >
                        Manufacturing Operations Management
                    </button>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(activeTab === "tab4" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab4")}
                    >
                        Service Management
                    </button>
                </div>

                <div className="container">
                    <div className="row">
                        {activeTab === "tab1" && (
                            <>
                                <DigitalIndustrytabsimages />

                            </>
                        )}
                        {activeTab === "tab2" && (
                            <>
                               <Digitalimagestabssingledata />
                            </>
                        )}
                        {activeTab === "tab3" && (
                            <>
                                <Digitalthirdtablogs />
                            </>
                        )}
                         {activeTab === "tab4" && (
                            <>
                                <Digitalimagestabssingledata />
                            </>
                        )}
                    </div>
                </div>
            </div>

        </div>
    );
};

export default DigitalmobilityTabscards;
